import image0 from "../../../../../../../../assets/images/design_masjid/MASJID_KALANG/00_masjid_kalang_cover.jpg";
import image1 from "../../../../../../../../assets/images/design_masjid/MASJID_KALANG/01_masjid_kalang.jpg";
import image2 from "../../../../../../../../assets/images/design_masjid/MASJID_KALANG/02_masjid_kalang.jpg";
import image3 from "../../../../../../../../assets/images/design_masjid/MASJID_KALANG/03_masjid_kalang.jpg";

let design_description = "Design Masjid"

export default [
  {
    title: "Masjid Kalang",
    description: design_description,
    urls: image0,
  },
  {
    title: "",
    description: design_description,
    urls: image1,
  },
  {
    title: "",
    description: design_description,
    urls: image2,
  },
  {
    title: "",
    description: design_description,
    urls: image3,
  }
];
